import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ContractTableDataSource } from './contract-list-datasource';
// import { OrdersService } from '../../services/orders.service';
import { ErrorService } from '../../../../@core/utils/error.service';
// import { Brewery } from '../../../../brewery-configuration/models/brewery';
import { faBinoculars, faCheck, faClone, faDemocrat, faEdit, faEye, faFileUpload, faHeadset, faHourglassHalf, faPrint, faSave, faSearch, faTimes, faTrash, faUpload, faWindowClose } from '@fortawesome/free-solid-svg-icons';
// import { BreweryService } from '../../../../brewery-configuration/service/brewery.service';
// import { Order, OrderLine } from '../../models/order';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';
import { SessionService } from '../../../../@core/utils/session.service';
// import { ReportService } from '../../../../../../../reports/report.service';
import * as moment from 'moment';
// import { BuildListService } from '../../services/build-list.service';
import { faFlag } from '@fortawesome/pro-duotone-svg-icons';
import { faCalendarAlt } from '@fortawesome/pro-solid-svg-icons';
import { forkJoin } from 'rxjs';
import { ExcelService } from '../../../../@core/utils/excel.service';
// import { OrderPriorityFlagComponent } from '../../widgets/order-priority-flag/order-priority-flag.component';
import { AuthService } from '../../../../@core/auth/auth.service';
import { VarietyService } from '../../../../harvest-engine/core/services/variety.service';
import { ContractDTO } from '../models/contract';
import { ContractLine } from '../models/lineItem';
import { ContractService } from '../services/contract.service';
import { PDFService } from '../services/pdf.service';
// import { CropVariety } from '../../../core/models/crop-variety';
import { InventoryPackageTypeService } from '../../../../harvest-engine/modules/inventory/services/inventory-package-type.service';
// import { InventoryPackageTypeDTO } from '../../inventory/models/inventory-package-type';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { InventoryService } from '../../../../harvest-engine/modules/pick-plan/services/inventory.service';
import { ConfirmationDialogComponent } from '../../../../partials/content/widgets/general/confirmation-dialog/confirmation-dialog.component';
import { FileUploadService } from '../../../core/services/FileUpload.service';
import { InventoryItemDTO } from '../../inventory/models/item';
import { PopupModalComponent } from '../widgets/popup-modal/popup-modal.component';
// import { Modal } from 'ngx-modialog/plugins/bootstrap';



@Component({
  selector: 'contract-list',
  templateUrl: './contract-list.component.html',
  styleUrls: ['./contract-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class ContractListComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  expandedElement: ContractTableDataSource | null;
  dataSource: ContractTableDataSource;

  confirmationVisible = false;
  public faBinoculars = faBinoculars;
  public faHeadset = faHeadset;
  public faHourglassHalf = faHourglassHalf;
  public faTimes = faTimes;
  public faCheck = faCheck;
  public faSearch = faSearch;
  public faPrint = faPrint;
  public faWindowClose = faWindowClose;
  public faSave = faSave;
  public faEdit = faEdit;
  public faFileUpload = faFileUpload;
  public faUpload = faUpload;
  public faTrash = faTrash;
  faCalendarAlt = faCalendarAlt;
  faFlag = faFlag;
  faDemocrat = faDemocrat;
  faEye = faEye;
  faClone = faClone;
  rowConfirm: object = {};

  public allSelected: boolean = false;
  public salesReps: string[] = [];
  public allData: ContractDTO[] = [];
  public isLoading: boolean = false;
  public isDownloading: boolean = false;
  public searchCustomer: string = '';
  public searchContractType: string = '';
  public searchContractYear: string = '';
  public searchStatus: string = '';
  public searchSalesRep: string = '';
  // public allVarieties: CropVariety[];
  // public allPackageTypes: InventoryPackageTypeDTO[];
  public allInventoryItems: InventoryItemDTO[];


  public searchStatuses: string[] = ['Pending', 'Preparing for Shipment', 'Flagged Orders'];

  public selectedPickListDate: Date = new Date();

  // public allBreweries: Brewery[] = [];
  public statuses: string[] = [];
  public selectedDate: string;
  public date: string = moment().format('2020-08-31T00:00:00.000Z');
  public files: File[] = [];

  constructor(
    // public orderService: OrdersService,
    public errorService: ErrorService,
    // public breweryService: BreweryService,
    private router: Router,
    public session: SessionService,
    // public reportService: ReportService,
    public excelService: ExcelService,
    // public buildListService: BuildListService,
    private matDialog: MatDialog,
    public authService: AuthService,
    public contractService: ContractService,
    public pdfService: PDFService,
    public varietyService: VarietyService,
    public inventoryPackageTypeService: InventoryPackageTypeService,
    public inventoryService: InventoryService,
    public fileUploadService: FileUploadService,
    private dialog: MatDialog
    // private modal: Modal
  ) {
  }

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['customerName', 'contractType', 'contractYear', 'effectiveDate', 'expirationDate', 'status', 'salesRep', 'edit', 'upload', 'ammend', 'view', 'delete'];

  ngOnInit() {
    this.dataSource = new ContractTableDataSource(this.paginator, this.sort);

    this.getContracts();

  }

  config = {
    url: 'http://localhost:3000/upload',
    maxFiles: 1,
    acceptedFiles: 'image/jpeg, image/png, application/pdf'
  };

  // onFileUpload(event) {
  //   
  //   // Handle the uploaded file here
  // }
  onFileUpload(event) {
    // 
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    // 
    this.files.splice(this.files.indexOf(event), 1);
  }
  viewContract(row){
    this.fileUploadService.getContractFileUploads(row.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:(res) => {
      // console.log(res)
      if (res.length > 0) {
        // 
        const byteCharacters = atob(res[0].fileByte);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const file = new Blob([byteArray], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      } else {
        if (row.contractVerbiage.includes('AGREEMENT TO MODIFY')) {
          row.contractVerbiage = row.contractVerbiage.replace(
            `["auto","*","*"]`,
            `["60%","20%","20%"]`
          );
        }
    const isQuote = row.contractTemplateName ==='Quote';

    isQuote
      ? this.pdfService.openQuotePDF(JSON.parse(row.contractVerbiage), row.customerName)
      : this.pdfService.openPDF(JSON.parse(row.contractVerbiage), row.customerName);
      }
    }, error:err => {
      this.errorService.handleError(err);
    }})
  }

  //Upgrade: Changed this modal with Material dialog
  showConfirmation(row) {
    this.rowConfirm = row;
    // this.confirmationVisible = true;
    // let dialogRef = this.modal.confirm()
    //   .size('sm')
    //   .isBlocking(true)
    //   .showClose(false)
    //   .keyboard(27)
    //   .title('Confirmation')
    //   .body('Are you sure you want to delete this contract?')
    //   .okBtn('Yes')
    //   .okBtnClass('btn btn-danger')
    //   .cancelBtn('No')
    //   .cancelBtnClass('btn btn-secondary')
    //   .open();

    // dialogRef.result
    //   .then((result) => {
    //     if (result) {
    //       // Confirmation was accepted
    //       this.deleteContract(this.rowConfirm);
    //       this.rowConfirm = {};
    //     } else {
    //       // Confirmation was canceled
    //       this.rowConfirm = {};
    //     }
    //   })
    //   .catch(() => {
    //     // Error handling
    //     this.rowConfirm = {};
    //   });

    const confRef = this.dialog
      .open(ConfirmationDialogComponent, {
        minWidth: "10%",
        data: {
          confirmLabel: "Yes",
          title: "Confirmation",
          confirmMessage: "Are you sure you want to delete this contract?",
          cancelLabel: "No",
        },
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe((result) => {
        if (result === true) {
          // Confirmation was accepted
          this.deleteContract(this.rowConfirm);
          this.rowConfirm = {};
        } else {
          // Confirmation was canceled
          this.rowConfirm = {};
        }
      });
  }

  // confirm() {
  //   this.deleteContract(this.rowConfirm)
  //   this.confirmationVisible = false;
  // }

  // cancel() {
  //   // Code to handle cancellation
  //   this.rowConfirm = {};
  //   this.confirmationVisible = false;
  // }

  deleteContract(row) {
    this.contractService.deleteContract(row.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      this.getContracts();
    })
  }

  openFileUpload(row) {
    // 
    const confRef = this.matDialog.open(PopupModalComponent, {
      minWidth: '35%',
      data: {
        row: row,
      }
    }).afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {
      this.getContracts();
    });
  }


  getContracts() {
    this.isLoading = true;
    
    forkJoin([
      this.contractService.getContracts(),
      // this.varietyService.getVarieties(),
      // this.inventoryPackageTypeService.getAll(),
      this.inventoryService.getInventoryItems()
    ]
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:(data: any) => {
      // this.allVarieties = data[1];
      // this.allPackageTypes = data[2];
      this.allInventoryItems = data[1];
      
      data[0].forEach(d => {
        // for testing purpose make isLocked  false for frontend side
       // d.isLocked = false ;
        d.contractLine.forEach(l => {
          // l.varietyName = this.allVarieties.find(v => v.id == l.varietyId).name || "";
          // l.packageName = this.allPackageTypes.find(p => p.id == l.packageId).name || "";

          if (l.inventoryItemId) {
            const foundItem = this.allInventoryItems.find(i => i.id === l.inventoryItemId);
            l.inventoryItemName = foundItem ? foundItem.name : "";
          
          }
        })
      })
    
      this.dataSource.data = data[0];
      this.allData = data[0];
      // 

      this.isLoading = false;
      this.paginator._changePageSize(this.paginator.pageSize);
      this.searchNoDate();

    }, error:err => this.errorService.handleError(err)});
  }

  onSearch() {
    this.isLoading = true;
    // 
    this.dataSource.data.map(d => {
      // 
    })
    this.dataSource.data = [...this.allData.filter(d =>
      (d.customerName || '').toLowerCase().includes(this.searchCustomer.toLowerCase())
      && (d.contractTemplateName || '').toLowerCase().includes(this.searchContractType.toLowerCase())
      && (d.contractYear || '').toString().toLowerCase().includes(this.searchContractYear.toLowerCase())
      && (d.status || '').toLowerCase().includes(this.searchStatus.toLowerCase())
      && (d.salesRepName || '').toLowerCase().includes(this.searchSalesRep.toLowerCase())
    )];


    this.updateOrders();
    this.isLoading = false;
  }

  updateOrders() {
    this.paginator.firstPage();
    this.paginator._changePageSize(this.paginator.pageSize);
  }

  downloadBuildList() {

  }

  getSubtotal(lines: ContractLine[]) {
    let total: number = 0;

    if (lines != null) {
      for (let x of lines) {
        if (x.price != undefined || x.price != null) {
          total = total + (x.price * x.quantity);
        }
      }
      return total;
    }
  }

  getTotalQty(lines: ContractLine[]) {
    let total: number = 0;
    if (lines != null) {
      for (let x of lines) {
        if (x.quantity != undefined || x.quantity != null) {
          total = total + x.quantity;
        }
      }
      return total;
    }
  }

  getTotalItems(lines: ContractLine[]) {

  }

  printPickList() {

  }

  navigateToContractEdit(contract: ContractDTO) {
    const url = contract.contractTemplateName == 'Amendment'
      ? `/harvest-engine/contracts/contract-ammend?contractId=${contract.id}&edit=true`
      : `/harvest-engine/contracts/contract-input?contractId=${contract.id}`;
    window.open(url, '_blank');
  }

  goToContractAmmend(contract: ContractDTO) {
    const url = `/harvest-engine/contracts/contract-ammend?contractId=${contract.id}&edit=false`;
    window.open(url, '_blank');
  }

  searchNoDate() {


  }

  flagOrder(order: ContractLine) {
    // this.session.order = { ...order };
    // const confRef = this.matDialog.open(PopupModalComponent, {
    //   minWidth: '35%',
    //   data: {
    //     order: order,
    //   }
    // }).afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {

    // order.flag = this.session.order.flag;
    // order.flagColor = this.session.order.flagColor;
    // order.flagComments = this.session.order.flagComments;

    // this.dataSource.data = _.sortBy(this.dataSource.data, [function (item) {
    //   return item.flag;
    // }, function (item) {
    //   return item.orderDate;
    // }]).reverse();

    // this.session.order = {};

    // this.updateOrders();
    // });
  }

  selectAllStatuses() {

  }

  onChange() {
    this.selectedPickListDate = moment(this.selectedDate).toDate();
  }
}

